import { ICD9Procedure } from '@dreryk/egabinet-icd-dictionary-frontend-api';

import { createObjectSchema, createStringSchema } from '@dreryk/react-draft';

export const icd9ProcedureSchema = createObjectSchema<ICD9Procedure>({
   code: createStringSchema(),
   name: createStringSchema(),
});
